import { SegmentedControl } from '@creditornot/cb-segmented-control';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { RelativeMonth } from '../types';

type MonthSelectorProps = {
  activeRelativeMonth: RelativeMonth;
  setActiveRelativeMonth: (relativeMonth: RelativeMonth) => void;
};

const MonthSelectorContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px;
`;

export const MonthSelector = ({ activeRelativeMonth, setActiveRelativeMonth }: MonthSelectorProps) => {
  const { formatMessage } = useIntl();
  const RelativeMonthText: Record<RelativeMonth, string> = {
    [RelativeMonth.NEXT_MONTH]: formatMessage({ id: 'best-of-wolt.relative-months.next' }),
    [RelativeMonth.THIS_MONTH]: formatMessage({ id: 'best-of-wolt.relative-months.this' }),
    [RelativeMonth.LAST_MONTH]: formatMessage({ id: 'best-of-wolt.relative-months.last' }),
  };
  return (
    <MonthSelectorContainer>
      <ChipsContainer>
        <SegmentedControl<RelativeMonth>
          options={Object.values(RelativeMonth).map(relativeMonth => ({
            label: RelativeMonthText[relativeMonth],
            value: relativeMonth,
          }))}
          value={activeRelativeMonth}
          onChange={value => setActiveRelativeMonth(value)}
        />
      </ChipsContainer>
    </MonthSelectorContainer>
  );
};
